import { createContext } from 'react';

import { TabsState } from './types';

export const TabsContext = createContext<TabsState<any> | undefined>(undefined);
